// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__FRcOv","productName":"Table_productName__3Xc5x"};